export default __webpack_public_path__ + "static/media/teams.02738216.svg";